module.exports = __webpack_public_path__ + "img/dokanios-750.adcd77f6.jpg";